export const Apps = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="40" height="40" rx="20" fill="#CAD1D3"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M11 15.001H15V11H11V15.001ZM18 15.001H22V11H18V15.001ZM29 15.001H25V11H29V15.001ZM18 22H22V18H18V22ZM29 22H25V18H29V22ZM11 22H15V18H11V22ZM22 29H18V25H22V29ZM25 29H29V25H25V29ZM15 29H11V25H15V29Z" fill="#435254"/>
  </svg>
);
